<template>
  <van-cell-group>
      <template slot="title">
          服务店铺:{{ shop_name }}
      </template>
    <van-cell>
        <template slot="title">
            地址:{{ address }}
        </template>
    </van-cell>
    <van-cell>
        <template slot="title">
            电话:{{ contace_mobile }}
        </template>
    </van-cell>
    <van-cell>
        <template slot="title">
            联系人:{{ contact_name }}
        </template>
    </van-cell>
</van-cell-group>  
</template>

<script>
import { 
    CellGroup,
    Cell
} from 'vant'
import { CurShopInfoApi } from '@/api/market'

export default {
    name: 'UsedCarFooter',
    components: {
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell
    },
    data() {
        return {
            shop_name: null,
            address: null,
            contace_mobile: null,
            contact_name: null
        }
    },
    mounted() {
        var that = this
        that.axios.get(CurShopInfoApi, {}).then((ret) => {
            if (ret.flag) {
                that.shop_name = ret.details.shop_name
                that.address = ret.details.address
                that.contace_mobile = ret.details.contace_mobile
                that.contact_name = ret.details.contact_name
                that.$emit('returnShopInfo', that)
            }
        })
    },
    methods: {}
}
</script>
